/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiPersonCategory {
    COUNTERPARTY = 'COUNTERPARTY',
    CUSTOMER = 'CUSTOMER'
}


export function instanceOfApiPersonCategory(value: any): boolean {
    for (const key in ApiPersonCategory) {
        if (Object.prototype.hasOwnProperty.call(ApiPersonCategory, key)) {
            if (ApiPersonCategory[key as keyof typeof ApiPersonCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApiPersonCategoryFromJSON(json: any): ApiPersonCategory {
    return ApiPersonCategoryFromJSONTyped(json, false);
}

export function ApiPersonCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiPersonCategory {
    return json as ApiPersonCategory;
}

export function ApiPersonCategoryToJSON(value?: ApiPersonCategory | null): any {
    return value as any;
}

export function ApiPersonCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): ApiPersonCategory {
    return value as ApiPersonCategory;
}

